var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConversationEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.38 62L25.916 60L32.844 48H44C46.208 48 48 46.21 48 44V34H52V44C52 48.418 48.418 52 44 52H35.154L29.38 62Z",
    fill: "url(#paint0_linear_6332_7718)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 4H56C58.208 4 60 5.792 60 8V20C60 22.208 58.208 24 56 24H50V20H56V8H36V20H43.154L47.774 28L44.308 30L40.846 24H36C33.792 24 32 22.208 32 20V8C32 5.792 33.792 4 36 4ZM12 52C7.582 52 4 48.418 4 44V24C4 19.582 7.582 16 12 16H28V20H12C9.79 20 8 21.79 8 24V44C8 46.21 9.79 48 12 48H24V52H12ZM18 34C18 35.104 18.896 36 20 36C21.104 36 22 35.104 22 34C22 32.896 21.104 32 20 32C18.896 32 18 32.896 18 34ZM28 36C26.896 36 26 35.104 26 34C26 32.896 26.896 32 28 32C29.104 32 30 32.896 30 34C30 35.104 29.104 36 28 36ZM34 34C34 35.104 34.896 36 36 36C37.104 36 38 35.104 38 34C38 32.896 37.104 32 36 32C34.896 32 34 32.896 34 34Z",
    fill: "url(#paint1_linear_6332_7718)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6332_7718",
    x1: 29.4311,
    y1: 34,
    x2: 48.6628,
    y2: 34.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6880"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6332_7718",
    x1: 11.5467,
    y1: 4,
    x2: 52.8104,
    y2: 5.68738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6880"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationEmpty);
export default __webpack_public_path__ + "static/media/conversation-empty.0bae6e31a86cf6dd1f1667bdb75254c4.svg";
export { ForwardRef as ReactComponent };